import "./App.css";
import Header from "./components/Header";
import Departments from "./components/Departments";
import Footer from "./components/Footer";

function App() {
  return (
    <div>

      <Header />

      <Departments />

      <div className="content">
        <h1>BCU Previous Year Question Papers</h1>

<h2>Download Bangalore City University Study Materials</h2>

<p>
This academic platform provides a complete collection of BCU previous year question papers,
textbooks, model papers and solved papers for students studying under Bangalore City University.
The website is designed to help students easily access important academic resources.
</p>

<h3>BCU Textbooks, Model Papers and Solved Papers</h3>
       <p>
Students from BCA, BCOM, BSC and BBA departments can download subject-wise textbooks,
model papers and previous year solved question papers. These materials help students
prepare effectively for semester examinations.
</p>

<h4>Department Wise Study Materials</h4>

<p>
Our academic website organizes resources department-wise so that students can easily
navigate between courses and find the required subjects quickly. With a simple interface,
students can explore study materials and improve their exam preparation.
</p>

      </div>
<Footer/>
    </div>
  );
}

export default App;